import { FilterType, PreviewItemFilterOption } from "@ponder-shared/tools/filter/preview-item-filter-option";
import { MagicColorFilterOption } from "./magic-card-filter-color";
import { CollectedItemDetails, MagicCard } from "@apiserver-rest/ponder-data-client-base";
import { FilteredPreviewItem } from "@ponder-shared/tools/filter/filtered-preview-item";
import { producesBlack, producesBlue, producesColorless, producesGreen, producesRed, producesWhite } from "../magicCardUtils";

export class MagicCardFilterMana extends PreviewItemFilterOption {

    public options: MagicManaFilterOptions = {
        white: { enabled: true, count: 0 },
        blue: { enabled: true, count: 0 },
        black: { enabled: true, count: 0 },
        red: { enabled: true, count: 0 },
        green: { enabled: true, count: 0 },
        colorless: { enabled: true, count: 0 },
        none: { enabled: true, count: 0 },
        or: true
    };

    private all: boolean = true;
    private mask: number = MagicManaColorFlag.All;

    constructor() {
        super("Mana", FilterType.MagicManaProduction, "", "", "");
    }

    public prepare(): void {
        // ... nothing ...
    }

    public track(magicCard: MagicCard, collectedInfo: CollectedItemDetails | undefined): void {
        this.getMatchingOptions(magicCard).forEach(o => {
            o.count++;
        });
    }

    private getMatchingOptions(magicCard: MagicCard): MagicColorFilterOption[] {
        var options: MagicColorFilterOption[] = [];

        var black = producesBlack(magicCard);
        var white = producesWhite(magicCard);
        var red = producesRed(magicCard);
        var green = producesGreen(magicCard);
        var blue = producesBlue(magicCard);
        var colorless = producesColorless(magicCard);
        
        if (white) { options.push(this.options.white); }
        if (blue) { options.push(this.options.blue); }
        if (black) { options.push(this.options.black); }
        if (red) { options.push(this.options.red); }
        if (green) { options.push(this.options.green); }
        if (colorless) { options.push(this.options.colorless); }

        if (options.length == 0) {
            options.push(this.options.none);
        }

        return options;
    }

    public updateSelection(selection: string, page: string): boolean {
        this.setStoredFilter(selection, page);
        return true;
    }

    public updateManaSelection(white: boolean, blue: boolean, black: boolean, red: boolean, green: boolean, colorless: boolean, none: boolean, or: boolean, page: string): void {
        var newMask = this.getBitMask(white, blue, black, red, green, colorless, none);

        if ((this.mask == newMask) && (this.options.or == or)) {
            return;
        }

        this.options.white.enabled = white;
        this.options.blue.enabled = blue;
        this.options.black.enabled = black;
        this.options.red.enabled = red;
        this.options.green.enabled = green;
        this.options.colorless.enabled = colorless;
        this.options.none.enabled = none;
        this.options.or = or;

        this.all = white && blue && black && red && green && colorless && none;
        this.mask = newMask;
        this.wasUpdated = true;

        this.setStoredFilter(JSON.stringify(this.options), page);
    }

    public getFilters(): Map<string, number | undefined> {
        // ... nothing ...
        return new Map<string, number | undefined>();
    }

    public isValid(magicCard: MagicCard, collectedInfo: CollectedItemDetails | undefined): boolean {
        if (this.all && this.options.or) {
            return true;
        }

        var cardBitMask = magicCard.manaMask ?? MagicManaColorFlag.None;

        if (this.options.or) {
            return ((cardBitMask & this.mask) != 0);
        } else {
            return (cardBitMask == this.mask);
        }
    }

    private getBitMask(w: boolean | undefined, u: boolean | undefined, b: boolean | undefined, r: boolean | undefined, g: boolean | undefined, c: boolean | undefined, n: boolean | undefined): number {
        return (w ? MagicManaColorFlag.White : 0) + 
               (u ? MagicManaColorFlag.Blue : 0) + 
               (b ? MagicManaColorFlag.Black : 0) + 
               (r ? MagicManaColorFlag.Red : 0) + 
               (g ? MagicManaColorFlag.Green : 0) + 
               (c ? MagicManaColorFlag.Colorless : 0) +
               (n ? MagicManaColorFlag.None : 0);
    }
    
    public sort(previewItems: FilteredPreviewItem[]): void {
        // ... nothing ...
    }

    public override setUserInfo(isCollection: boolean, isAuthed: boolean): void {
        // ... nothing ...
    }
}

export type MagicManaFilterOptions = {
    white: MagicColorFilterOption;
    blue: MagicColorFilterOption;
    black: MagicColorFilterOption;
    red: MagicColorFilterOption;
    green: MagicColorFilterOption;
    colorless: MagicColorFilterOption;
    none: MagicColorFilterOption;
    or: boolean;
};

enum MagicManaColorFlag {
    Unknown   = 0b00000000,
    White     = 0b00000001,
    Blue      = 0b00000010,
    Black     = 0b00000100,
    Red       = 0b00001000,
    Green     = 0b00010000,
    Colorless = 0b00100000,
    None      = 0b01000000,
    All       = 0b11111111
};